import _ from 'lodash';

export const selectEasyWalkThroughForm = state => _.get(state, ['easyWalkThroughForm'], {});

export const selectEasyWalkThroughFormData = state => _.get(selectEasyWalkThroughForm(state), ['data'], {});
